import React, {useState,useEffect} from "react";
import Main from "../../components/template/Main";
import { useParams,useHistory } from "react-router-dom";
import { post,get,put } from "../../store/config/register";
import { toast } from "react-toastify";
import './TarefaComentario.css'


const initialState ={
    tarefa: {
      id: 0,
      idAtividade: 0,
      idTarefa: 0,
      descricao: ''
    }
  }

const headerProps = {
    icon: "comment-o",
    title: "Comentário",
    subtitle: "Cadastro"
}


export default function TarefaComentario(){
    const {id, idTarefa, idComentario} = useParams();
    const [tarefaComentario,setTarefaComentario] = useState(initialState.tarefa);
    const history = useHistory();

    function  updateField( event){
        const tare ={...tarefaComentario}
        tare[event.target.name] = event.target.value
        setTarefaComentario(tare);
    }

        useEffect(()=>{
            setTarefaComentario({...tarefaComentario, idAtividade: parseInt(id),idTarefa:parseInt(idTarefa)});
            if(idComentario !== undefined){
                buscaComentario(idComentario);
            }
        },[]);

        async function buscaComentario(IdComentario) {
           const come = await get(`/ComentarioAtividade/v1/Atividade/Tarefa?IdAtividade=${id}&idTarefa=${idTarefa}&id=${IdComentario}`)
        
           if(come !== undefined){
            setTarefaComentario(come);
           }
        }


    async function Salvar(tarefaComentario) {
         if(Validar()){
            if(idComentario === undefined){
                const res =  await post('/ComentarioAtividade/v1',tarefaComentario);
            }else {
                const res =  await put(`/ComentarioAtividade/v1/${id}`,tarefaComentario);
            }
                 
                    toast.success('comentário salvo com sucesso.')
                    history.goBack();
                }
    }

    function Validar(){

        if(tarefaComentario.descricao === ''){
            toast.warning('Escreva uma descrição');
            return false;
        }

        return true;
    }

    function renderForm(){
        return (
            <div className="form">
                <div className="email">
                    <div className="form-group">
                    <label>Descrição:</label>
                    <textarea  rows="1" type="text" name="descricao" placeholder="Descrição" onKeyDown={handleKeyDown}
                        className="form-control auto_height" value={tarefaComentario.descricao} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>

                <div id="botao">
                    <button  className="btn btn-primary ml-2" onClick={ async e => await Salvar(tarefaComentario)}>
                        Salvar
                    </button>
                    <button className="btn btn-secondary ml-2" onClick={e => history.goBack()}>
                        Cancelar
                    </button>
                </div>     
            </div>
        );
    }

  function  handleKeyDown(e) {
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight}px`; 
        // In case you have a limitation
        // e.target.style.height = `${Math.min(e.target.scrollHeight, limit)}px`;
      }

     // <textarea rows="1" class="auto_height" onInput="auto_height(this)"></textarea>
    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}